import { connect } from 'react-redux';
import { getClassificationProperty } from '../productDetailsUtils';
import GeneralInfo from './generalInfo';

const mapStateToProps = ({ detailsPage }) => ({
  productCode: detailsPage.loadedProduct.productCode,
  name: detailsPage.loadedProduct.name,
  description: detailsPage.loadedProduct.description,
  technology: getClassificationProperty(detailsPage.loadedProduct.classificationData, 'technology'),
  technologyGroup: getClassificationProperty(detailsPage.loadedProduct.classificationData, 'technologyGroup'),
  price: detailsPage.loadedProduct.price,
  wasPrice: detailsPage.loadedProduct.wasPrice,
  markdown: detailsPage.loadedProduct.markdown,
});

export default connect(mapStateToProps)(GeneralInfo);
